import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Differentials from "@/components/Differentials";
import HowItWorks from "@/components/HowItWorks";
import About from "@/components/About";
import Pricing from "@/components/Pricing";
import ConditionsShowcase from "@/components/ConditionsShowcase";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>English-Speaking Doctor in Brazil | Online Telemedicine</title>
        <meta name="description" content="Online English-speaking doctor across Brazil. Same-day video consults for tourists & expats with valid prescriptions. Book on WhatsApp daily 07:00-22:00." />
        <link rel="canonical" href="https://riomedcare.com.br/" />
        <meta property="og:url" content="https://riomedcare.com.br/" />
      </Helmet>
      <Header />
      <Hero />
      <Differentials />
      <HowItWorks />
      <ConditionsShowcase />
      <About />
      <Pricing />
      <Testimonials />
      <Contact />
      <FAQ />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
